<template>
  <v-dialog
    v-model="show"
    persistent
    fullscreen
    >
    <v-card flat>
      <v-toolbar class="ma-2" dense flat>
        <v-spacer/>
          <v-btn class="ma-1" small  fab @click="printDR()"><v-icon>mdi-printer</v-icon></v-btn>
          <v-btn class="ma-1" small fab @click="emitToParent('close')" color="error"><v-icon >mdi-close</v-icon></v-btn>
      </v-toolbar>
      <div id="printDR">
        <div class="print-size">
            <p class="text-center"><strong>{{business_name()}}</strong>
                    <br />{{business_address()}}<br />
                        VAT Reg. TIN: {{tin()}}
                </p>
                <br />
             
        <table class="print_table3" width="100%">
            <tr>
                <td>
                    SALESMAN: {{SALESMAN.fullname}} <br />
                    D.R. #: {{dr.number}} <br />
                    DATE: {{dr.created | moment($date_format)}} <br />
                </td>
                <td>
                        STATUS: {{dr.status}}<br />
                        OUTBOUND DATE: {{dr.outbound_date | moment($date_format)}} <br />
                       INBOUND DATE: {{dr.inbound_date | moment($date_format)}} 
                </td>
            </tr>
        </table>
      
       
      <table class="print_table3" width="100%">
                    <tr>
                        <td colspan="4" style="background: #e5e5e5;">FULL CONTENTS</td>
                    </tr>
                    <tr>
                        <td style="background: #EDEDED;">SKU</td>
                        <td style="background: #EDEDED;">QTY</td>
                        <td style="background: #EDEDED;" class="text-right">UNIT PRICE</td>
                        <td style="background: #EDEDED;" class="text-right">AMOUNT</td>
                    </tr>
                    <tr v-for="(item, index) in fulls" :key="index+'-f'">
                        <td>{{item.product_code}}</td>
                        <td>{{item.quantity}}</td>
                        <td class="text-right">{{$money(item.unit_price)}}</td>
                        <td class="text-right">{{$money(item.unit_price * item.quantity)}}</td> 
                    </tr>
                    <tr>
                        <td colspan="4" class="text-right">TOTAL LOAD VALUE:  {{$money(LOAD_TOTAL)}}</td>
                    </tr>
      </table>
        <table class="print_table3"  width="100%" style="vertical-align:top;">
            <tr>
             
                <td width="50%"  style="vertical-align:top;">
                       <table width="100%">
                           <tr>
                                 <td colspan="4" style="background: #e5e5e5;">GENERATED - RETURNED FULLS</td>
                            </tr>
                            <tr>
                                <td style="background: #EDEDED;">CODE</td>
                                <td style="background: #EDEDED;" class="text-right">QTY</td>
                            </tr>
                            <tr v-for="(item,index) in returned_fulls" :key="index">
                            <td>{{item.product_code}}</td>
                            <td class="text-right">{{item.quantity}}</td>
                            </tr>
                       </table>
                </td>
                <td width="50%"  style="vertical-align:top;">
                    <table width="100%">
                           <tr>
                                 <td colspan="4" style="background: #e5e5e5;">GENERATED - RETURNED EMPTIES</td>
                            </tr>
                            <tr>
                                <td style="background: #EDEDED;">CODE</td>
                                <td style="background: #EDEDED;" class="text-right">QTY</td>
                            </tr>
                            <tr v-for="(item,index) in returned_empties" :key="index">
                            <td>{{item.product_code}}</td>
                            <td class="text-right">{{item.quantity}}</td>
                            </tr>
                    </table>
                </td>
            </tr>

             <tr>
             
                <td width="50%"  style="vertical-align:top;">
                       <table width="100%">
                           <tr>
                                 <td colspan="4" style="background: #e5e5e5;">CHECKER - RETURNED FULLS</td>
                            </tr>
                            <tr>
                                <td style="background: #EDEDED;">CODE</td>
                                <td style="background: #EDEDED;" class="text-right">QTY</td>
                            </tr>
                            <tr v-for="(item,index) in checked.full_items?checked.full_items:[]" :key="index">
                            <td>{{item.code}}</td>
                            <td class="text-right">{{item.qty}}</td>
                            </tr>
                       </table>
                </td>
                <td width="50%"  style="vertical-align:top;">
                    <table width="100%">
                           <tr>
                                 <td colspan="4" style="background: #e5e5e5;">CHECKER - RETURNED EMPTIES</td>
                            </tr>
                            <tr>
                                <td style="background: #EDEDED;">CODE</td>
                                <td style="background: #EDEDED;" class="text-right">QTY</td>
                            </tr>
                            <tr v-for="(item,index) in checked.empty_items?checked.empty_items:[]" :key="index">
                            <td>{{item.code}}</td>
                            <td class="text-right">{{item.qty}}</td>
                            </tr>
                    </table>
                </td>
            </tr>
        </table>

                        <table width="100%" class="print_table3">
                           <tr>
                                 <td colspan="5" style="background: #e5e5e5;">SALES</td>
                            </tr>
                            <tr>
                                <td style="background: #EDEDED;">INVOICE</td>
                                 <td style="background: #EDEDED;">CUSTOMER</td>
                                 <td style="background: #EDEDED;">DATE</td>
                                 <td style="background: #EDEDED;">PAYMENT</td>
                                 <td style="background: #EDEDED;" class="text-right">AMOUNT</td>
                            </tr>
                            <tr v-for="(item,index) in sales" :key="index">
                                <td>{{item.invoice}} 
                                </td>
                                    <td>{{item.trade_name}}</td>
                                    <td>{{item.delivered_date | moment($date_format)}}</td>
                                    <td>{{item.payment_type}}</td>
                                    <td class="text-right">{{$money(item.amount)}}</td>
                                </tr>
                    </table>

                    <table width="100%" class="print_table3">
                           <tr>
                                 <td colspan="6" style="background: #e5e5e5;">SETTLEMENT</td>
                            </tr>
                            <tr>
                                <td style="background: #EDEDED;">VALIDATION</td>
                                 <td style="background: #EDEDED;" class="text-right">FULL CONTENTS</td>
                                 <td style="background: #EDEDED;" class="text-right">DEPOSIT</td>
                                 <td style="background: #EDEDED;" class="text-right">RETURNED EMPTIES</td>
                                 <td style="background: #EDEDED;" class="text-right">DISCOUNTS</td>
                                 <td style="background: #EDEDED;" class="text-right">AMOUNT</td>
                            </tr>
                            <tr v-for="(item,index) in SUMMARY" :key="index" >
                                <td>{{item.label}}</td>
                                <td class="text-right">{{$money(item.fulls)}}</td>
                                <td class="text-right">{{$money(item.deposit)}}</td>
                                <td class="text-right">{{$money(item.empties)}}</td>
                                <td class="text-right text-warning">{{$money(item.discount)}}</td>
                                <td class="text-right">{{$money(item.amount)}}</td>
                          </tr>
                          <tr style="background: #efefef;" :class="SETTLEMENT_AMOUNT<0?'text-error':'text-success'">
                                <th colspan="5" class="text-right">SETTLEMENT AMOUNT</th>
                                <th class="text-right">{{$money(SETTLEMENT_AMOUNT)}}</th>
                            </tr>
                    </table>
                    <br />  <br />
               <table width="100%" class="print_table3">
                    <td>CHECKED BY:_____________</td>
                    <td>VERIFIED BY:_____________</td>
                    <td>CONFORME: {{SALESMAN.fullname}}</td>
               </table>
                 <br />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
       props: {
            show: {
                type: Boolean,
                default: false
            },
            dr: {
                type: Object,
                default: ()=>{}
            },
            checked: {
                type: Object,
                default: ()=>{}
            },
            fulls: {
                type: Array,
                default: ()=>[]
            },
            empties: {
                type: Array,
                default: ()=>[]
            },
            sales: {
                type: Array,
                default: ()=>{}
            },
            returned_fulls: {
                type: Array,
                default: ()=>[]
            },
            returned_empties: {
                type: Array,
                default: ()=>[]
            },
            checker_fulls: {
                type: Array,
                default: ()=>[]
            },
            checker_empties: {
                type: Array,
                default: ()=>[]
            },
       },
    data: () => ({
      confirm: false,
      print: false,
        sales_headers: [
        { text: 'INVOICE', value: 'product_code', sortable: false},
        { text: 'CUSTOMER', value: 'description', sortable: false},
        { text: 'DATE', value: 'description'},
        { text: 'PAYMENT', value: 'payment_type'},
         { text: 'OTHER DISC'},
        { text: 'AMOUNT',  align: 'right',sortable: false },
         ],
         full_headers: [
        { text: 'CODE', value: 'product_code', sortable: false},
        { text: 'DESC', value: 'description', sortable: false},
        { text: 'QTY', value: 'quantity', align: 'right', sortable: false},
        { text: 'UNIT PRICE', align: 'right', value: 'unit_price', sortable: false},
        { text: 'AMOUNT',  align: 'right',sortable: false },
         ],
         returned_headers:[
            { text: 'CODE'},
            { text: 'QTY', align: 'right'},
        ],
       summary_headers:[
              { text: 'VALIDATION'},
              { text: 'FULL CONTENTS', align: 'right'},
              { text: 'DEPOSIT',align: 'right'},
              { text: 'RETURNED EMPTIES', align: 'right'},
              { text: 'DISCOUNT', align: 'right'},
              { text: 'AMOUNT', align: 'right'},
        ],
        route:''
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
        //   this.SET_MENUS()
        //   this.setLoggedIn(true) 
        //   this.GET_USERS()
        //   this.GET_TRUCKS()
        //   this.GET_DRIVERS()
        //   this.GET_SUPPLIERS()
        //    this.GET_PRODUCTS()
        //   this.getDr()
        //   this.GET_AVAILABLES()
        }
    },
    computed:{
    SALESMAN(){
        var list = this.GET_SALESMEN()
        var salesman = list.reduce((res,item)=>{
            if(item.id == this.dr.salesman) {
                res =item
            }
            return res
        }, {})
        return salesman
    },
      CASH_SALES() {
        var total= this.sales.reduce((res,item)=>{
            if(item.payment_type == 'Cash'){
              res += this.$IsNum(item.amount)
            }
            return res
        },0)
        return total
      },
       CHEQUE_SALES() {
        var total= this.sales.reduce((res,item)=>{
            if(item.payment_type == 'Cheque'){
              res += this.$IsNum(item.amount)
            }
            return res
        },0)
        return total
      },
       CREDIT_SALES() {
        var total= this.sales.reduce((res,item)=>{
            if(item.payment_type == 'Credit'){
              res += this.$IsNum(item.amount)
            }
            return res
        },0)
        return total
      },
      OTHERDISCOUNTS() {
         var total= this.sales.reduce((res,item)=>{
            res += this.$IsNum(this.other_discounts(item.discounts))
            return res
        },0)
        return total
      },
      VOLUME_PROGRESS(){
        var vol = 0
        var val = 0
         if(this.TRUCK.capacity) {
            vol =  this.fulls.reduce((res, item)=>{
              res += this.$IsNum(item.quantity) * this.$IsNum(item.volume) 
              return res
            },0)
            val =  ((vol/this.$IsNum(this.TRUCK.capacity)) * 100).toFixed(0)
         }
        var param = {
            value: this.$IsNum(val),
            color: val<80?'success':'error', 
            remarks: this.$IsNum(val) + "% Load"
        }
        return param
      },
      WEIGHT_PROGRESS(){
        var weight = 0
         var val = 0
        if(this.TRUCK.weight) {
            weight =  this.fulls.reduce((res, item)=>{
              res += this.$IsNum(item.quantity) * this.$IsNum(item.weight) 
              return res
            },0)
            val =  ((weight/this.$IsNum(this.TRUCK.weight)) * 100).toFixed(0)
        }
         
        var param = {
            value: this.$IsNum(val),
            color: val<80?'success':'error', 
            remarks: this.$IsNum(val) + "% Load"
        }
        return param
      },
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      EDIT() {
        if(this.dr.status=='on-process'){
            return true
        }
        return false
      },
      TRUCK() {
         if(this.$store.state.trucks == undefined || this.$store.state.trucks == null) {
          return []
        }
        var arr = this.$store.state.trucks.reduce((res, item)=>{
            if(item.id==this.dr.truck) {
             res = item
            }
            return res
        },{})
        return arr
      },
      CONTAINERS(){
        var arr =  this.$store.state.products.reduce((res, item)=>{
            if(item.type=="empties"  && item.sort>0) {
                res.push(item)
            }
            return res
        },[])
        return arr
      },
      EMTPTIESTOTAL() {
        var total =  this.empties.reduce((res, item)=>res += (this.$IsNum(item.deposit) - this.$IsNum(item.refund)) * this.$IsNum(item.unit_price),0)
        return total
      },
      LOAD_TOTAL() {
        var total =  this.fulls.reduce((res, item)=>res += this.$IsNum(item.quantity)* this.$IsNum(item.unit_price),0)
        return total
      },
      DISCOUNT_TOTAL:function(){
        return this.SOLD_TOTAL + this.SOLD_DEPOSIT_TOTAL - this.RETURNED_EMPTIES_TOTAL - this.SALES_TOTAL
      },
      SALES_TOTAL() {
          var total =  this.sales.reduce((res, item)=>res += this.$IsNum(item.amount),0)
          return total
      },
       RETURNED_FULLS_TOTAL() {
          var total =  this.returned_fulls.reduce((res, item)=>res += this.$IsNum(item.quantity)* this.$IsNum(item.unit_price),0)
          return total
      },
      RETURNED_EMPTIES_TOTAL() {
          var total =  this.returned_empties.reduce((res, item)=>res += this.$IsNum(item.refund)* this.$IsNum(item.unit_price),0)
          return total
      },
      CHECKER_EMPTIES_TOTAL() {
           var data = this.checked.empty_items?this.checked.empty_items:[]
          var total =  data.reduce((res, item)=>res += this.$IsNum(item.qty) * this.$IsNum(item.unit_price),0)
          return total
      },
      CHECKER_FULLS_TOTAL() {
          var data = this.checked.full_items?this.checked.full_items:[]
          var total =  data.reduce((res, item)=>res += this.$IsNum(item.qty) * this.$IsNum(item.unit_price),0)
          return total
      },
      SOLD_DEPOSIT_TOTAL() {
          var total =  this.returned_empties.reduce((res, item)=>res += this.$IsNum(item.deposit)* this.$IsNum(item.unit_price),0)
          return total
      },

      SOLD_TOTAL(){
          return this.LOAD_TOTAL - this.RETURNED_FULLS_TOTAL 
      },
      CHECKER_SOLD_TOTAL(){
          return this.LOAD_TOTAL - this.CHECKER_FULLS_TOTAL 
      },
      CHECKER_SALES_TOTAL(){
          return this.CHECKER_SOLD_TOTAL +  this.SOLD_DEPOSIT_TOTAL - this.CHECKER_EMPTIES_TOTAL - this.DISCOUNT_TOTAL
      },
      SUMMARY(){
        return [
          {label:"GENERATED", fulls: this.SOLD_TOTAL, deposit: this.SOLD_DEPOSIT_TOTAL, empties: this.RETURNED_EMPTIES_TOTAL, discount:this.DISCOUNT_TOTAL, amount:this.SALES_TOTAL },
          {label:"CHECKER", fulls: this.CHECKER_SOLD_TOTAL, deposit: this.SOLD_DEPOSIT_TOTAL, empties: this.CHECKER_EMPTIES_TOTAL, discount:this.DISCOUNT_TOTAL, amount: this.CHECKER_SALES_TOTAL },
        ]
      },
      SETTLEMENT_AMOUNT(){
          return  this.SALES_TOTAL - this.CHECKER_SALES_TOTAL
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      emitToParent (action) {
            this.$emit('DialogEvent', action)
        },
        printDR () {
        // Pass the element id here
        this.$htmlToPaper('printDR');
        }
     
    },
  }
</script>